import { SiteAction } from 'common/types'

export function getUploadSummary(siteActions: SiteAction[]): string {
  const counts = siteActions.reduce(
    (acc, currSiteActions) => {
      switch (currSiteActions) {
        case SiteAction.Ignore:
        case SiteAction.Review:
          return { ...acc, ignore: acc.ignore + 1 }
        case SiteAction.New:
          return { ...acc, new: acc.new + 1 }
        case SiteAction.Sold:
          return { ...acc, sold: acc.sold + 1 }
        case SiteAction.Update:
          return { ...acc, update: acc.update + 1 }
      }
    },
    {
      new: 0,
      ignore: 0,
      sold: 0,
      update: 0,
    }
  )
  const summaries: string[] = []
  if (counts.new > 0) {
    summaries.push(
      `${counts.new} new site${counts.new > 1 ? 's' : ''} will be added`
    )
  }
  if (counts.ignore > 0) {
    summaries.push(
      `${counts.ignore} site${counts.ignore > 1 ? 's' : ''} will be ignored`
    )
  }
  if (counts.sold > 0) {
    summaries.push(
      `${counts.sold} existing site${
        counts.sold > 1 ? 's' : ''
      } will be marked as sold`
    )
  }
  if (counts.update > 0) {
    summaries.push(
      `${counts.update} existing site${
        counts.update > 1 ? 's' : ''
      } will be updated`
    )
  }
  return `${summaries.join('\n')}\n\n${
    siteActions.length
  } total (valid) sites in upload list`
}
